import axios, { AxiosInstance } from 'axios';
import { getToken, removeToken } from "../data/storage";
import { toast } from "react-toastify";

const axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL as string,
    timeout: 5000,
});

axiosInstance.defaults.headers.common['Authorization'] = getToken();
axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';
axiosInstance.interceptors.request.use((config) => {
    const token = getToken();
    if (!!token) {
        config.headers['Authorization'] = token;
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        let errMsg: string = error?.response?.data?.message;
        if (error.response && error.response.status === 400 && !errMsg) {
            const errorMessages: string[] = error.response.data.messages;
            if (!!errorMessages && errorMessages.length > 0) {
                errMsg = errorMessages.join(", ")
            }
        }
        if (!errMsg) errMsg = "ERROR Occurred";

        const errorCode = error?.response?.data?.errorCode;
        if (errorCode !== 'error.phoneNumberInUse') {
            toast.error(errMsg, { theme: "colored" })
        }

        if (error.response && error.response.status === 401) {
            removeToken();
            if (!(error?.config?.url === "/users/login")) {
                window.location.href = "/login"
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;